import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import { Row, Col } from "react-bootstrap";
import { MdOutlineModeEditOutline, MdSupervisedUserCircle, MdAccountCircle } from "react-icons/md";

import Lead from "../../shared/Lead";
import * as API from "../../api";
import Loading from "../../shared/Loading";
import Select from "../../shared/Select";
import TextArea from "../../shared/TextArea";
import PriorityBadge from "../../shared/PriorityBadge";
import InternalCommunicationForm from './InternalCommunicationForm';

import SelectAssignee from "./SelectAssignee";
import { Task, Settings } from "../../helpers/Contexts";
import Patient from "../../shared/Patient";
import FieldError from "../../shared/FieldError";

const OrderRequestForm = ({ task, dispatch, isCall, formHandler }) => {
  const [error, setError] = useState("");
  const [taskSubmitted, setTaskSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const settings = useContext(Settings);
  const history = useHistory();

  const TaskSchema = Yup.object().shape({
    priority: Yup.string().oneOf(["low", "medium", "high"]).nullable(),
    type: Yup.string().required("Request type is required."),
    notes: Yup.string().required("Notes is required"),
    assignee: Yup.string().required(
      "Assignee is required. Select a support group or agent to be assigned to this task."
    ),
  });

  return (
    <>
      <Formik
        initialValues={{ priority: "", type: "", assignee: "", notes: "", assignee_id: "", assignee_support_group_id: "" }}
        onSubmit={(values) => {
          let request = {
            task_type: "order_request",
            status: "open",
          };
          task.patient
            ? (request = {
                ...request,
                patient_id: task.patient.id,
              })
            : null;
          setLoading(true);
          API.postTask({
            task: {
              ...request,
              priority: values.priority,
              notes: values.notes,
              assignee_id: values.assignee_id && values.assignee_id,
              assignee_support_group_id:
                values.assignee_support_group_id && values.assignee_support_group_id,
              assigner_id: settings.me.id,
              assigner_support_group_id: settings.me.support_group_id,
            },
          }).then((res) => {
            console.log(res);
            setLoading(false);
            dispatch({ type: "set_loading", payload: true });
            history.push(`/physicians/tasks/item/${res.task.id}`);
            setTaskSubmitted(true);
          })
          .catch((err) => {
            console.log(err);
            setError(err);
          });
        }}
      >
        {({ values, setFieldValue, isSubmitting, errors }) => {
          return (<>
            <Form>
              <Row className=" flex pad20">
                <Col md={5} className="pad20 form">
                  <Lead message={"New Order Request"} />
                  <br />
                  <br />
                  <SelectAssignee name="assignee" setFieldValue={setFieldValue} />
                  <Select label="Priority" name="priority" value={values.priority}>
                    <option value={""}> {"Choose a priority level"}</option>
                    <option value={"low"}>Low</option>
                    <option value={"medium"}>Medium</option>
                    <option value={"high"}>High</option>
                  </Select>
                  <TextArea
                    label="Notes"
                    value={values.notes}
                    name="notes"
                    placeholder="Please write additional notes"
                  />
                  <button id="btn outline" type="submit">
                    Submit Order Request
                  </button>
                </Col>
                <Col md={7} className={"pad20 border-container"}>
                  {loading && !taskSubmitted && <Loading message={"Creating Task "} />}
                  {task.patient && task.patient.id && <Patient patient={{ ...task.patient }} />}
                  <label className="agent">
                    {"Assignee "}{" "}
                    <span id="from">
                      {" "}
                      {values.assignee_id && values.assignee_support_group_id && (
                        <>
                          <MdAccountCircle className="task-agent" />
                          <b> {values.assignee}</b>
                        </>
                      )}
                      {!values.assignee_id && values.assignee_support_group_id && (
                        <>
                          {" "}
                          <MdSupervisedUserCircle className="task-agent" />
                          <b>{values.assignee} </b>
                        </>
                      )}
                    </span>
                  </label>

                  <hr />
                  <Lead message={"Order Request"} />
                  <br />
                  <br />
                </Col>
              </Row>
            </Form>
          </>);
          }}
      </Formik>
    </>
  );
};

export default OrderRequestForm;
